import React, { useState, useEffect, useRef } from 'react';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from "../../../config/firebase"; 

const DefaultMessages = ({ isLoading, setIsLoading, actionButtons }) => {
  // Convert actionButtons object to array of {key, value}
  const defaultMessages = actionButtons 
    ? Object.entries(actionButtons).map(([key, value]) => ({ key, value }))
    : [];

const setCookie = (name, value, days = 30) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
};
  const getCurrentTimeString = () => {
    const currentTime = new Date();
    let hours = currentTime.getHours();
    const minutes = currentTime.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")} ${ampm}`;
  };

const getCookie = (name) => {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split("=")[1]) : null;
};
  const handleMessageClick = (buttonItem) => {
  
    saveActionToFirestore(buttonItem.value); // Pass value instead of key
  };

  function getCurrentISTDate() {
    const date = new Date();
    const utcOffset = date.getTimezoneOffset();
    const istOffset = 330;
    const istDate = new Date(date.getTime() + (istOffset + utcOffset) * 60000);
    return `${istDate.getFullYear()}-${String(istDate.getMonth() + 1).padStart(2, '0')}-${String(istDate.getDate()).padStart(2, '0')}`;
  }

  const saveActionToFirestore = async (actionText) => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const currentDomain = urlParams.get("parentUrl");
      const shopId = currentDomain || "null";
      const uidvar = currentDomain + "uid";
      let uid = getCookie(uidvar) || "";

      const currentTimeString = getCurrentTimeString();
      const currentTime = new Date();
      const seconds = currentTime.getSeconds();
      const month = String(currentTime.getMonth() + 1).padStart(2, "0");
      const day = String(currentTime.getDate()).padStart(2, "0");
      const year = currentTime.getFullYear();
      const formattedHours = String(currentTime.getHours() % 12 || 12).padStart(2, "0");
      const formattedMinutes = String(currentTime.getMinutes()).padStart(2, "0");
      const date_string = `${month}/${day}/${year}, ${formattedHours}:${formattedMinutes}:${seconds}`;

      const data_var = currentDomain + "myData";
      const storedData = getCookie(data_var);
      let docid = "";

      if (!storedData) {
        const initialData = { key: uid + Date.now().toString() };
        setCookie(data_var, JSON.stringify(initialData));
        docid = initialData.key;
      } else {
        const parsedData = JSON.parse(storedData);
        docid = parsedData.key;
      }

      const docRef = doc(db, "Messages", docid);
      const docSnap = await getDoc(docRef);
      let assigned_to = "bot@krunk.ai";

      if (docSnap.exists()) {
        const message = docSnap.data().Messages;
        assigned_to = docSnap.data().assigned_to;
        message.push({
          user: `${actionText} `,
          user_timestamp: date_string,
          time: currentTimeString
        });

        await setDoc(docRef, {
          Messages: message,
          server: false,
          user_id: docid,
          shop_id: shopId,
          User_Channel: "Web",
          timestamp: Date.now(),
          last_updated: serverTimestamp(),
        }, { merge: true });
      } else {
        await setDoc(docRef, {
          Chat_Status: "Open",
          Fetch_Firestore: true,
          Messages: [
           
            { user: actionText, user_timestamp: date_string, time: currentTimeString }
          ],
          server: false,
          user_id: uid,
          shop_id: shopId,
          User_Channel: "Web",
          timestamp: Date.now(),
          ticket_id: docid,
          assigned_to: "bot@krunk.ai",
          doc_id: docid,
          User_Timestamp: getCurrentISTDate(),
          created_at: serverTimestamp(),
          last_updated: serverTimestamp(),
        }, { merge: true });
      }

      if (assigned_to === "bot@krunk.ai") {
        setIsLoading(true);
        let url = "";

        if (shopId === "null") {
          //  url='https://yaan-man.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"YaanMan";
          url = 'http://127.0.0.1:8080/server?docid=' + docid +  "&shop_id=" + "quickstart-86e3bb23.myshopify.com" +"&user_message=" + actionText;
          
        } else if (shopId === "Krunk.ai") {
          url = "https://krunk-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=" + docid + "&shop_id=" + "Krunk.ai";
        } else if (shopId === "HomesterOnboardingProperties") {
          url = 'https://homesteronboarding.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "Krunk.ai";
        } else if (shopId === "JustWravels") {
          url = 'https://modular-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid +  "&shop_id=" + "JustWravels" +"&user_message=" + actionText;
          
        
        } else if (shopId === "DivineHindu") {
          url = 'https://divine-hindu-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "JustWravels";
        } else if (shopId === "smilenbeauty") {
          url = 'https://smile-n-beauty.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "JustWravels";
        }
       else if(shopId=="YaanMan"){
          url='https://yaan-man.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"YaanMan";
        } else if (shopId === "indidiva.com") {
          //  url='https://yaan-man.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"YaanMan";
          url = 'https://modular-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid +  "&shop_id=" + "5a76ef-91.myshopify.com" +"&user_message=" + actionText;
          
          
       
        }
        

        if (url) {
          fetch(url, { method: 'GET' })
            .then(() => setIsLoading(false))
            .catch((err) => console.log("Error:", err));
        }
      }

    } catch (error) {
      console.error("Error saving action to Firestore:", error);
    }
  };

  return (
    <div 
      className="absolute bottom-4 right-4 space-y-2 z-10"
      style={{ position: 'absolute', bottom: '16px', right: '16px', zIndex: 1000 }}
    >
      {defaultMessages.map((buttonItem, index) => (
        <div
          key={index}
          className="krunk-bg-bubblecolor text-primary1color px-4 py-2 rounded-lg shadow-lg cursor-pointer hover:bg-blue-600 transition-colors max-w-xs ml-auto block"
          style={{
           
            padding: '7px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            cursor: 'pointer',
            maxWidth: '200px',
            marginLeft: 'auto',
            marginBottom: '8px',
            fontSize: '13px'
          }}
          onClick={() => handleMessageClick(buttonItem)}
        >
          {buttonItem.key}
        </div>
      ))}
    </div>
  );
};

export default DefaultMessages;
